import React 		        from 'react';
import ReactDOM 	        from 'react-dom';
import App 					from './components/App.react.js';
import render 				from 'react-dom';

if( document.getElementById( 'content' ) ) {

	ReactDOM.render( <App />, document.getElementById( 'content' ) );
}



// WEBPACK FOOTER //
// ./resources/assets/js/app.js